var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIcon8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.291,
    height: 20.461,
    viewBox: "0 0 16.291 20.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12503",
    "data-name": "Group 12503",
    transform: "translate(714.14 -513.788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5514",
    "data-name": "Rectangle 5514",
    width: 15.291,
    height: 19.461,
    transform: "translate(-713.64 514.288)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5515",
    "data-name": "Rectangle 5515",
    width: 11.359,
    height: 6.665,
    transform: "translate(-711.674 524.946)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_296",
    "data-name": "Line 296",
    x2: 11.359,
    transform: "translate(-711.674 527.167)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297",
    "data-name": "Line 297",
    y2: 6.691,
    transform: "translate(-702.706 524.945)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298",
    "data-name": "Line 298",
    y2: 6.691,
    transform: "translate(-704.89 524.945)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_299",
    "data-name": "Line 299",
    y2: 6.691,
    transform: "translate(-709.259 524.945)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38485",
    "data-name": "Path 38485",
    d: "M53.445,627.912a11.437,11.437,0,0,0,2.424.364c1.06,0,2.12-.678,2.12-1.515s-1.484-1.363-2.12-1.515-2.121-.678-2.121-1.515,1.06-1.514,2.121-1.514a16.806,16.806,0,0,1,2.423.242",
    transform: "translate(-765 -105.962)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_300",
    "data-name": "Line 300",
    x2: 0.03,
    y2: 8.271,
    transform: "translate(-709.131 515.284)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    x2: 5.62,
    transform: "translate(-705.591 515.887)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    x2: 5.62,
    transform: "translate(-705.591 518.111)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    x2: 5.62,
    transform: "translate(-705.591 520.335)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    x2: 5.62,
    transform: "translate(-705.591 522.559)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon8);
export default __webpack_public_path__ + "static/media/sidebar-icon-8.fadadcf8daa8ab7af7a4d4b1124e80c4.svg";
export { ForwardRef as ReactComponent };